<po-page-default p-title="Lançamento de rubricas" [p-breadcrumb]="breadcrumb">
  <div class="po-row">
    <po-container class="po-lg-12 po-md-12 po-sm-12">
      <div class="cabecalho-lancamento">
        <span class="po-font-text-uppercase">
          <span class="an an-currency-dollar"></span>
          Folha do eSocial na Domínio
        </span>
        <div class="atalho-cadastro">
          <po-button
            p-size="small"
            p-kind="secondary"
            p-icon="an an-list-numbers"
            p-label="Cadastro de rubricas"
            (p-click)="irParaCadastro()">
          </po-button>
          <span class="atalho-indicativo">Para a rubrica que não subiu</span>
        </div>
      </div>

      <div class="po-lg-12 po-mb-4 destaque">
        <p class="po-font-text-large po-mb-1">
          Envie o pacote do eSocial. A Domínio recebe as férias, as rubricas da folha e as rescisões, mês a mês.
        </p>
        <p>
          <b>
            A planilha que baixa mostra o que foi enviado. A última aba lista as rubricas que não subiram.
            Com "Somente rescisão" ligado, só as rescisões são lançadas.
          </b>
        </p>
      </div>

      <div class="aviso po-lg-12 po-mb-3" *ngIf="avisos.length">
        <p *ngFor="let aviso of avisos">
          <span class="an an-warning"></span>
          {{ aviso }}
        </p>
      </div>

      <div class="po-lg-6 po-md-12">
        <app-empresa-combo
          name="codiEmp"
          label="Empresa"
          [(ngModel)]="codiEmp"
          [disabled]="enviando">
        </app-empresa-combo>
      </div>

      <div class="po-lg-4 po-md-6 po-sm-12">
        <po-input
          name="aPartirDe"
          p-label="A partir de"
          p-placeholder="dd/mm/aaaa"
          p-help="Em branco, entra a partir de 01/12/2025."
          [(ngModel)]="aPartirDe">
        </po-input>
      </div>

      <po-switch
        class="po-lg-4 po-md-6 po-sm-12"
        name="somenteRescisoes"
        p-label="Somente rescisão"
        p-label-on="Sim"
        p-label-off="Não"
        [(ngModel)]="somenteRescisoes"
        [p-disabled]="enviando">
      </po-switch>

      <div class="po-lg-12">
        <po-upload
          #uploadEsocial
          [p-restrictions]="esocialRestrictions"
          p-size="medium"
          [p-drag-drop]="true"
          [p-multiple]="true"
          [p-drag-drop-height]="150"
          [p-url]="urlPlaceholder"
          [p-hide-send-button]="true"
          [p-disabled]="enviando"
          p-label="Arquivos do eSocial (.xml ou .zip)">
        </po-upload>
      </div>

      <po-button
        class="po-lg-4 po-mt-3"
        p-icon="an an-paper-plane-tilt"
        p-label="Lançar"
        (p-click)="lancar()"
        [p-loading]="enviando"
        [p-disabled]="enviando">
      </po-button>
    </po-container>
  </div>
</po-page-default>
